var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VPopover',{attrs:{"trigger":"hover","placement":"bottom"}},[_c('ListButton',{attrs:{"img-src":_vm.allowEdit ? '/icons/edit.svg' : '/icons/chevron-right.svg',"disabled":_vm.disabled},on:{"click":function($event){return _vm.onClick()}}}),_c('template',{slot:"popover"},[_c('main',[_vm._v(_vm._s(_vm.displayedTooltip))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }